<div fxLayout="column" fxLayoutAlign="space-around center">
    <h2 class="center-text">CCP Advanced Notification Configuration</h2>
    <div>
        <div fxLayout="row" fxLayoutAlign="space-around center">
            <div fxLayout="row" class = "margin">
                <div id="customerAgent">                
                <select [(ngModel)]="selectedLOB">
                    <option value="" disabled selected hidden>Select LOB</option>
                    <option class="custom-option" *ngFor="let lob of lobList" [ngValue]="lob[1]" >{{lob[0]}}</option>
                </select>
            </div>
            <div fxLayout="row" class = "margins">
                <div>
                    <textarea matInput class = "textarea" [(ngModel)]="message" placeholder="Ex. An update will occur..."></textarea>
                </div>
            </div>
            <div fxLayout="row" class = "margin"> 
                <div id="expirationConfiguration" class = "margin">                  
                    <p class="center">End Date</p>
                    <input type="date" [(ngModel)]="endDate"/>
                </div>
                <button mat-raised-button color="primary" id="activate" (click)="submitAdvancedNotification()">Activate</button>
            </div>
        </div>
    </div>
    <div>
        <mat-tab-group>
            <mat-tab label="Active">
                <div id="table">
                    <app-mat-data-grid 
                        class="page-data-grid"
                        [formValid]="true"
                        [header]="header"
                        [(dataSource)]="advancedNotificationData" 
                        [displayedColumns]="['lob', 'notification', 'endDate', 'created', 'creator']"   
                        [columnNames]="['LOB', 'Message', 'End Date', 'Created', 'Creator']"
                        [columnFormatters]="{'lob': formatLOBFunction}"
                        [pageSizeOptions] = "[5, 15, 25, 50]"
                        [buttonConfig]="{
                            edit: {show: false},
                            delete: {show: true},
                            create: {show: false}
                        }"
                        (buttonClick)="handleAdvancedNotificationButtonEvent($event)">
                    </app-mat-data-grid>
                    <ng-template #header>
                        <button mat-raised-button color="primary" (click)="buildCSV();">Download CSV</button>
                    </ng-template>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
    <div class="error" *ngIf="displayError()">
        {{lambdaMessage}}
    </div>
</div>
<a id="downloadLink" hidden></a>